import React, { useMemo, useContext } from "react";
import LogViewMessageDetailsRow from "logview/components/LogViewMessageDetailsRow";
import { useFormattedFields } from "components/common/message/details";
import MessageFavoriteFieldsContext from "views/components/contexts/MessageFavoriteFieldsContext";
const LogViewMessageDetailsRows = ({
  columns,
  renderFieldName = void 0,
  renderFieldValue = void 0,
  onSelect,
  editing
}) => {
  const { favoriteFields } = useContext(MessageFavoriteFieldsContext);
  const { formattedFavorites, formattedRest } = useFormattedFields(favoriteFields);
  const sortedRows = useMemo(() => formattedFavorites.concat(formattedRest), [formattedFavorites, formattedRest]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, sortedRows.map(({ field, value, type }, index) => /* @__PURE__ */ React.createElement(
    LogViewMessageDetailsRow,
    {
      key: `${field}-${value}`,
      field,
      value,
      type,
      onSelect: () => onSelect(field),
      selected: columns.includes(field),
      renderFieldName,
      renderFieldValue,
      hideCheckbox: editing,
      isFavorite: (formattedFavorites == null ? void 0 : formattedFavorites.length) && index < formattedFavorites.length
    }
  )));
};
export default LogViewMessageDetailsRows;
